export const tr = {
    'empty-price': 'Belirtilmedi',
    from: 'ile',
    to: 'arası'
};
